import PropTypes from 'prop-types';

FriendsgivingCustomizeAlerts.propTypes = {
  alertsMuted: PropTypes.bool.isRequired,
  setAlertsMuted: PropTypes.func,
};

export default function FriendsgivingCustomizeAlerts({
  alertsMuted,
  setAlertsMuted = (_) => {},
}) {
  return (
    <div
      className={`border-2 rounded px-2 py-1 transition-all ${alertsMuted ? 'bg-base-200 shadow' : 'text-white! bg-warning/40 border-warning/50 shadow'}`}
    >
      <div className="form-control">
        <label className="label cursor-pointer">
          <span className="label-text">Muted</span>
          <input
            type="checkbox"
            checked={alertsMuted}
            onChange={(e) => setAlertsMuted(e.target.checked)}
            className="checkbox"
          />
        </label>
      </div>
    </div>
  );
}
